import { useEffect, useState } from "react";
import api from "../api";
import { Card, CardContent, Button, Typography, Stack, Chip, AppBar, Toolbar } from "@mui/material";
import { logout } from "../utils/auth";


export default function AdminFeedback() {
  const [list, setList] = useState([]);

  const load = async () => {
    const res = await api.get("/feedback");
    setList(res.data);
  };

  useEffect(() => {
    load();
  }, []);

  const formatDate = (date) =>
    new Date(date).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });

  return (
    <>
      <AppBar position="static">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6">Admin Dashboard</Typography>
          <Button color="inherit" onClick={logout}>Logout</Button>
        </Toolbar>
      </AppBar>
      <Stack spacing={2} sx={{ p: 3 }}>
        {list.map((f) => (
          <Card key={f._id}>
            <CardContent>
              <Typography variant="h6">{f.name}</Typography>
              <Typography>{f.message}</Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                Date: {formatDate(f.createdAt)}
              </Typography>

              <Stack direction="row" spacing={1} mt={2}>
                {f.resolved && <Chip label="Resolved" color="success" />}
                {!f.resolved && (
                  <Button size="small" onClick={() => api.patch(`/feedback/${f._id}/resolve`).then(load)}>
                    Resolve
                  </Button>
                )}
                <Button size="small" color="error" onClick={() => api.delete(`/feedback/${f._id}`).then(load)}>
                  Delete
                </Button>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </>
  );
}
